const InfiniteScroll = {
  mounted() {
    let options = {
      root: document,
      rootMargin: '0px',
      threshold: [1]
    }

    let callback = (entries, observer) => {
      entries.forEach(entry => {
        console.log('to')
        console.log(entry)
        console.log(entry.isIntersecting)
        if (entry.isIntersecting) {
          this.pushEvent("check_for_more", {})
        }
      });
    };

    this.observer = new IntersectionObserver(callback, options);
    let target1 = this.el
    this.observer.observe(target1);
  },
  destroyed() {
    this.observer.disconnect();
  }
}

export default { InfiniteScroll }
